import { createUseLocalStorage } from "@catchy/app-core";
import { postLocalStorageNativeMessage } from "@/lib/nativeStorageBridge";
import { getStorageKey } from "@/lib/regions/client";

export default createUseLocalStorage({
  getStorageKey,
  postStorageMessage: postLocalStorageNativeMessage,
});
